import React from "react";

export default function ClaimDetailsModal({ show, onClose, claims, loading }) {
	if (!show) return null;

	return (
		<div className="claim-modal-overlay">
			<div className="claim-modal">
				<div className="claim-modal-header">
					<h5>Claim Details</h5>

					<button onClick={onClose}>✕</button>
				</div>

				<div className="claim-modal-body">
					{loading ? (
						<p>Loading...</p>
					) : claims.length === 0 ? (
						<p>No Claims Found</p>
					) : (
						claims.map((claim, index) => (
							<div key={index} className="claim-row">
								<div>
									<b>{claim.mobileNo}</b>
								</div>

								<div>{claim.status}</div>
							</div>
						))
					)}
				</div>
			</div>
		</div>
	);
}
